import { categoriesTypes } from "../constantes/actionTypes"

const initialState = []

export const categories = (state = initialState, action) => {
    switch (action.type) {
        case categoriesTypes.GET_ALL_CATEGORIES_SUCCESS:
            return action.payload
        case categoriesTypes.NEW_CATEGORY_SUCCESS:
            return [...state, action.payload]
        case categoriesTypes.UPDATE_CATEGORY_SUCCESS:
            const updateCategories = state.map(item => {
              if (item.id_TipoCategoria === action.payload.id_TipoCategoria)
                return action.payload
              return item
            })
            return updateCategories
        case categoriesTypes.DELETE_CATEGORY_SUCCESS:
            return state.filter(item => item.id_TipoCategoria !== action.payload.id_TipoCategoria)
        case categoriesTypes.NEW_CATEGORY_FAILURE:
        case categoriesTypes.UPDATE_CATEGORY_FAILURE:
        case categoriesTypes.DELETE_CATEGORY_FAILURE:
            return state
        case categoriesTypes.GET_ALL__CATEGORIES_FAILURE:
            return initialState
        default:
            return state
    }
}